import { AfterViewInit, Component, NgZone, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { BuildingsService } from "../../../service/buildings.service";

import * as _ from "lodash";
import { Router } from "@angular/router";
import { eventEmitterService } from "../../../service/eventEmitter.service";
import { Observable, Subscription, timer } from "rxjs";
import { tap } from "rxjs/operators";

declare var $: any;
declare var jQuery: any;

@Component({
  selector: "app-alerts",
  templateUrl: "./alerts.component.html",
  styleUrls: ["./alerts.component.css"],
})
export class AlertsComponent implements OnInit, AfterViewInit {
  // Form variables
  buildingAlertForm: FormGroup;
  editBuildingAlertForm: FormGroup;

  buildingAlerts = [];
  allBuildingAlerts;
  filteredBuildingAlerts;
  buildingAlertsLength;

  myBuildings;
  selectedBuildings = [];
  selectedBuildingsName = [];
  filteredBuildings = [];
  allBuildings = [];
  buildingArray = [];
  buildingNames = [];
  createdName = "";
  expiryDateInvalid = false;
  subjectInvalid = false;
  messageInvalid = false;
  editExpiryDateInvalid = false;
  editSubjectInvalid = false;
  editMessageInvalid = false;
  isExpired = false;
  today;
  editedName = "";
  editAlertId = "";
  editBuildingNames = [];
  editSubjectSub = "";
  editMessageSub = "";
  editExpiration = "";
  editCheckedBuildingId = [];
  editCheckedBuildingName = [];
  Names: any;
  isCreated = false;
  isError = false;

  unreadAlerts = 0;
  timer: Subscription;
  managerBuildingSubscription: Subscription;
  residentBuildingSubscription: Subscription;
  alertNotificationTimer;
  unreadAlertSubscription: Subscription;

  // Get current loggedIn user ID
  id = localStorage.getItem("residents");
  isManager = localStorage.getItem("isManager");
  userBuildingId = localStorage.getItem("userBuildingId");

  ifresidentsHasBuilding = [];
  pageUrl;

  constructor(
    private _fb: FormBuilder,
    private buildingService: BuildingsService,
    private ngZone: NgZone,
    private router: Router,
    private eventEmit: eventEmitterService
  ) {}

  ngOnInit() {
    this.eventEmit.eventEmit$.subscribe((url) => {
      if (url.currentPageUrl) {
        this.pageUrl = url.currentPageUrl;
      }
    });

    this.today = new Date();

    console.log("Is Manager : ", this.isManager);

    self["io"].socket.on("activityfeed", (alerts) => {
      console.log({ alerts });
      if (alerts.data.alerts) {
        if (this.myBuildings.length <= 1) {
          alerts.data.alerts.building = this.ifresidentsHasBuilding;
        }
        this.buildingAlerts.unshift(alerts.data.alerts);
        if (this.pageUrl == "/buildings/alerts") {
          this.eventEmit.alert$.next("reset");
        }
      }
      if (alerts.data.editAlert) {
        var editAlert = alerts.data.editAlert;
        if (this.myBuildings.length <= 1) {
          alerts.data.editAlert.building = this.ifresidentsHasBuilding;
        }
        this.buildingAlerts = this.buildingAlerts.map(function (item) {
          return item.id == editAlert.id ? editAlert : item;
        });
      }

      if (alerts.data.deleteAlert) {
        var deleteAlert = alerts.data.deleteAlert;
        this.buildingAlerts = this.buildingAlerts.filter(
          (item) => item.id !== deleteAlert.id
        );
      }
    });

    this.buildingAlertForm = this._fb.group({
      expirationDate: ["", [Validators.required]],
      subject: ["", [Validators.required]],
      message: ["", [Validators.required]],
      singleBuildingId: [""],
    });

    this.editBuildingAlertForm = this._fb.group({
      editExpirationDate: ["", [Validators.required]],
      editSubject: ["", [Validators.required]],
      editMessage: ["", [Validators.required]],
      singleBuildingId: [""],
    });

    // Runs every 10 seconds to check if the user is logged in, if hos session is logged out the redirects to home page
    this.ngZone.runOutsideAngular(() => {
      this.timer = timer(1000, 10000) // Initial delay of 1000ms and interval of 10000ms
        .pipe(
          tap(() => {
            this.ngZone.run(() => {
              if (this.id === undefined || this.id === "") {
                location.href = "/";
              }
            });
          })
        )
        .subscribe();
    });

    /**
     * Fetch all building alerts from DB based on the role of a user
     */
    if (this.isManager == "true") {
      this.buildingService.getAllBuildingAlerts(this.id).subscribe((data) => {
        //console.log('Building Alerts : ', data);
        if (data.success) {
          this.buildingAlerts = data.alerts;
          this.allBuildingAlerts = data.alerts;
        }
        this.buildingAlertsLength = this.buildingAlerts.length;
      });
    } else {
      this.buildingService
        .getAllBuildingAlertsByBuiildingId(this.userBuildingId)
        .subscribe((data) => {
          //console.log('Building Alerts : ', data.alerts);
          if (data.success) {
            this.buildingAlerts = data.alerts;
            var tempAlerts = [];
            for (let buildingAlert of this.buildingAlerts) {
              if (buildingAlert.building[0]) {
                tempAlerts.push(buildingAlert);
              }
            }
            this.buildingAlerts = tempAlerts;
          }
        });
      if (this.isManager !== "true") {
        // Get all unread building alerts for a resident
        this.buildingService
          .updateUnreadAlertCount(this.id, this.userBuildingId)
          .subscribe((data) => {
            var tempAlert = [];
            for (let alert of data.alerts) {
              if (alert.readBy.length > 0) {
                tempAlert.push(alert);
              }
            }
            localStorage.setItem("unreadAlerts", tempAlert.length.toString());
          });
      }
    }

    /**
     * Get all building information based on user ID
     * This information will be used during filtering alerts based on building
     */
    this.buildingService
      .getAllBuildingsByUserId(this.id)
      .subscribe((buildings) => {
        //console.log(buildings.data[0].building);
        if (buildings.success) {
          this.myBuildings = buildings.data[0].building;
          //console.log('My Buildings: ', this.myBuildings);
          if (this.myBuildings.length <= 1) {
            this.allBuildings.push(this.myBuildings[0].id);
            this.ifresidentsHasBuilding.push(this.myBuildings[0]);
          } else {
            for (let building of this.myBuildings) {
              this.allBuildings.push(building.id);
            }
          }
        }
      });

    var dateToday: any = new Date();

    $("#date_pick").datepicker({
      minDate: 1,
      onSelect: (dateText, inst) => {
        //console.log('dateText : ', dateText);
        this.editBuildingAlertForm.controls["editExpirationDate"].setValue(
          dateText
        );
      },
    });
    $("#date_pick_edit").datepicker({
      minDate: 1,
      onSelect: (dateText, inst) => {
        //console.log('dateText : ', dateText);
        this.buildingAlertForm.controls["expirationDate"].setValue(dateText);
      },
    });
    jQuery.browser = {};
    (function () {
      jQuery.browser.msie = false;
      jQuery.browser.version = 0;
      if (navigator.userAgent.match(/MSIE ([0-9]+)\./)) {
        jQuery.browser.msie = true;
        jQuery.browser.version = RegExp.$1;
      }
    })();

    // Set all error flags on init so that the error are displayed on the go for building alert creation and edit form
    if (
      this.buildingAlertForm.get("expirationDate").invalid &&
      this.buildingAlertForm.get("expirationDate").touched
    ) {
      this.expiryDateInvalid = true;
    }

    if (
      this.buildingAlertForm.get("subject").invalid &&
      this.buildingAlertForm.get("subject").touched
    ) {
      this.subjectInvalid = true;
    }

    if (
      this.buildingAlertForm.get("message").invalid &&
      this.buildingAlertForm.get("message").touched
    ) {
      this.messageInvalid = true;
    }

    if (
      this.editBuildingAlertForm.get("editExpirationDate").invalid &&
      this.editBuildingAlertForm.get("editExpirationDate").touched
    ) {
      this.expiryDateInvalid = true;
    }

    if (
      this.editBuildingAlertForm.get("editSubject").invalid &&
      this.editBuildingAlertForm.get("editSubject").touched
    ) {
      this.subjectInvalid = true;
    }

    if (
      this.editBuildingAlertForm.get("editMessage").invalid &&
      this.editBuildingAlertForm.get("editMessage").touched
    ) {
      this.messageInvalid = true;
    }
  }

  ngAfterViewInit() {
    // Reset building alert form when modal popup is closed
    var that = this;
    $(document).on("hide.bs.modal", "#addbuildingmodal", function () {
      that.expiryDateInvalid = false;
      that.subjectInvalid = false;
      that.messageInvalid = false;
      that.editExpiryDateInvalid = false;
      that.editSubjectInvalid = false;
      that.editMessageInvalid = false;
      $("div.checkbox_inputs")
        .find('input[type="checkbox"]')
        .each(function (index, ele) {
          console.log("is Checked valv", $(this).prop("checked"));
          $(this).prop("checked", false);
        });
    });
  }

  /**
   * Ptach all values of a building alert to them form
   * when edit building alert isd clicked for a single building alert
   * -----------------------------------------
   * @param alert
   * @param {any} element
   */

  setAlertId(alert, element = null) {
    console.log("Element", element, this.myBuildings);
    this.editCheckedBuildingId = [];
    this.selectedBuildings = [];
    this.selectedBuildingsName = [];
    this.editCheckedBuildingName = [];
    this.editedName = "";
    for (let building of alert.building) {
      this.editCheckedBuildingId.push(building.id);
      this.editCheckedBuildingName.push(
        building.buildingName
          ? building.buildingName
          : building.formattedAddress.split(",")[0]
      );
    }
    this.selectedBuildings = this.editCheckedBuildingId;
    this.selectedBuildingsName = this.editCheckedBuildingName;
    this.editedName = this.selectedBuildingsName.toString();
    console.log(
      "This alert buildings for checkbox display",
      this.editCheckedBuildingId
    );
    console.log(
      "This alert buildings for checkbox display Name",
      this.editedName
    );
    this.editAlertId = alert.id;
    this.editBuildingAlertForm.get("editMessage").patchValue(alert.message);
    this.editBuildingAlertForm.get("editSubject").patchValue(alert.subject);
    var startDate = new Date(alert.expirationDate)
      .toLocaleDateString("en-US")
      .slice(0, 10);
    this.editBuildingAlertForm.get("editExpirationDate").patchValue(startDate);

    if (this.myBuildings.length > 1) {
      for (let building of this.myBuildings) {
        if (this.editCheckedBuildingId.indexOf(building.id) > -1) {
          $(element)
            .find("input#checkbox_" + building.id)
            .prop("checked", true);
        }
      }
    } else {
      if (this.editCheckedBuildingId.indexOf(this.myBuildings[0].id) > -1) {
        $(element)
          .find("input#checkbox_" + this.myBuildings[0].id)
          .prop("checked", true);
      }
    }
  }

  showAllBuildings() {
    $("#all_building_drp").toggle();
  }

  showAllFormBuildings() {
    $("#all_building_drp_modal").toggle();
  }
  showAllFormBuildings1(buildingListManager) {
    $(buildingListManager).find(".dropdown-content").toggleClass("show");
  }

  /**
   * Handles even submit, when Building Alert form is submitted
   * The input values are taken from Form Control declared in ngOnInit
   * This method, first performs validation on the submitted fields, sets various error flags if validation fails
   * If all values passes validation, the values are submitted to the service that connects to the backend
   * and stores values in DB
   * Response: Created alert value as per BuildingAlert Model in Sails
   */

  onBuildingAlertSubmit() {
    if (this.buildingAlertForm.get("expirationDate").invalid) {
      this.expiryDateInvalid = true;
    } else {
      this.expiryDateInvalid = false;
    }

    if (this.buildingAlertForm.get("subject").invalid) {
      this.subjectInvalid = true;
    } else {
      this.subjectInvalid = false;
    }

    if (this.buildingAlertForm.get("message").invalid) {
      this.messageInvalid = true;
    } else {
      this.messageInvalid = false;
    }

    const formData = this.buildingAlertForm.value;
    const expDate = formData.expirationDate;
    const subject = formData.subject;
    const message = formData.message;
    //console.log('Select buildings : ', this.selectedBuildings);
    //console.log('Select buildings : ', this.selectedBuildings.length);
    //console.log('All buildings : ', this.allBuildings);
    const buildingIds =
      this.selectedBuildings.length > 0
        ? this.selectedBuildings
        : this.allBuildings;

    if (subject.trim().length <= 0) {
      this.subjectInvalid = true;
    } else {
      this.subjectInvalid = false;
    }

    if (message.trim().length <= 0) {
      this.messageInvalid = true;
    } else {
      this.messageInvalid = false;
    }

    if (
      this.buildingAlertForm.valid &&
      !this.subjectInvalid &&
      !this.messageInvalid &&
      !this.expiryDateInvalid
    ) {
      this.buildingAlertForm.reset();
      const alertData = {
        building: buildingIds,
        expirationDate: expDate,
        subject: subject,
        message: message,
        createdBy: this.id,
      };

      this.buildingService
        .saveBuildingAlert(alertData)
        .subscribe((response) => {
          console.log("Building Alert Saved ? :", response);
          if (response.success) {
            this.buildingAlertForm.reset();
            this.refreshData();
            $("div.checkbox_inputs")
              .find("div.checkbox_inputs")
              .find('input[type="checkbox"]')
              .each(function (index, ele) {
                console.log($(this));
                $(this).prop("checked", false);
              });
            this.isCreated = true;
            this.filteredBuildings = [];
            setTimeout(() => {
              $("button.close").trigger("click");
              this.isCreated = false;
              this.isError = false;
            }, 3000);
          } else {
            this.isCreated = false;
            this.isError = true;
          }
        });
    }
  }

  /**
   * Handles edit building alert form submission
   * Performs validation, raises error if validation fails
   * Send form values to alert service if validation passes
   * Response: edited building alert
   */
  onBuildingAlertUpdateSubmit() {
    //console.log(this.editBuildingAlertForm.value);
    console.log(this.editBuildingAlertForm.valid);
    if (this.editBuildingAlertForm.get("editExpirationDate").invalid) {
      this.editExpiryDateInvalid = true;
    } else {
      this.editExpiryDateInvalid = false;
    }

    if (this.editBuildingAlertForm.get("editSubject").invalid) {
      this.editSubjectInvalid = true;
    } else {
      this.editSubjectInvalid = false;
    }

    if (this.editBuildingAlertForm.get("editMessage").invalid) {
      this.editMessageInvalid = true;
    } else {
      this.editMessageInvalid = false;
    }

    const formData = this.editBuildingAlertForm.value;
    const expDate = formData.editExpirationDate;
    const subject = formData.editSubject;
    const message = formData.editMessage;
    // Select building ID for the checked bixes of the buildings dropdown
    const building =
      this.selectedBuildings.length > 0
        ? this.selectedBuildings
        : this.allBuildings;

    if (subject.trim().length <= 0) {
      this.editSubjectInvalid = true;
    } else {
      this.editSubjectInvalid = false;
    }

    if (message.trim().length <= 0) {
      this.editMessageInvalid = true;
    } else {
      this.editMessageInvalid = false;
    }

    if (
      this.editBuildingAlertForm.valid &&
      !this.editSubjectInvalid &&
      !this.editMessageInvalid &&
      !this.editExpiryDateInvalid
    ) {
      console.log("Inside update");
      const alertData = {
        building: building,
        expirationDate: expDate,
        subject: subject,
        message: message,
        createdBy: this.id,
        alertId: this.editAlertId,
      };
      console.log("Alert Data ", alertData);

      this.buildingService
        .updateBuildingAlert(alertData)
        .subscribe((response) => {
          console.log("Building Alert Saved ? :", response);
          if (response.success) {
            this.buildingAlertForm.reset();

            this.isCreated = true;
            // Refresh data on successful submission
            this.refreshData();
            setTimeout(() => {
              $("button.close").trigger("click");
              this.isCreated = false;
              this.isError = false;
            }, 3000);
          } else {
            this.isCreated = false;
            this.isError = true;
          }
        });
    }
  }

  /**
   * Refresh building alert data from DB
   */
  refreshData() {
    this.buildingService.getAllBuildingAlerts(this.id).subscribe((data) => {
      console.log("Building Alerts : ", data);
      if (data.success) {
        this.buildingAlerts = data.alerts;
        this.allBuildingAlerts = data.alerts;
      }
    });
  }

  /**
   * Removes a created alert based on the alertId passed
   * @param alertId
   */
  removeAlert(alertId) {
    console.log("Alert to remove : ", alertId);
    this.buildingService.deleteAlert(alertId).subscribe((data) => {
      if (data.success) {
        this.refreshData();
      }
    });
  }

  /**
   * Stores building Ids of buildings that were selected from the building dropdown.
   * This will be used when creating or editing an alert
   * ------------------------------------
   * @param building
   * @param event
   * @param index
   */
  buildingCheckboxClicked(building, event, index) {
    if (event.target.checked) {
      this.selectedBuildings.push(building.id);
    } else {
      _.forEach(this.selectedBuildings, (val, key) => {
        if (val === building.id) {
          this.selectedBuildings.splice(this.selectedBuildings.indexOf(val), 1);
        }
      });
    }
    if (event.target.checked) {
      this.selectedBuildingsName.push(
        building.buildingName
          ? building.buildingName
          : building.formattedAddress.split(",")[0]
      );
    } else {
      _.forEach(this.selectedBuildingsName, (val, key) => {
        if (
          val ===
          (building.buildingName ||
            (building.buildingName
              ? building.buildingName
              : building.formattedAddress.split(",")[0]))
        ) {
          this.selectedBuildingsName.splice(
            this.selectedBuildingsName.indexOf(val),
            1
          );
        }
      });
    }
    this.createdName = this.selectedBuildingsName.toString();
    this.editedName = this.createdName;
  }

  /**
   * Used to store building IDs of selected buildings while filtering buildings based on ID
   * @param building
   * @param event
   * @param index
   */
  buildingFilterCheckboxClicked(building, event, index) {
    console.log(building.id, "Building ID");
    console.log(event.target.checked, "Event");
    console.log(index, "Index");
    this.Names = [];
    if (event.target.checked) {
      this.filteredBuildings.push(building.id);
      this.buildingArray.push(building.id);
      this.buildingNames.push(
        building.buildingName
          ? building.buildingName
          : building.formattedAddress.split(",")[0]
      );
    } else {
      _.forEach(this.filteredBuildings, (val, key) => {
        if (val === building.id) {
          this.filteredBuildings.splice(this.filteredBuildings.indexOf(val), 1);
        }
      });
      var ind = this.buildingArray.indexOf(building.id);
      if (ind > -1) {
        this.buildingArray.splice(ind, 1);
        this.buildingNames.splice(ind, 1);
      }
    }

    this.buildingNames.forEach((name) => {
      this.Names.push(name);
    });

    this.Names = this.Names.toString();
    var filteredAlerts = [];
    console.log("this.filteredBuildingAlerts", this.filteredBuildingAlerts);

    if (_.isEmpty(this.filteredBuildings)) {
      this.buildingAlerts = this.allBuildingAlerts;
      this.buildingAlertsLength = this.buildingAlerts.length;
    } else {
      if (this.residentBuildingSubscription) {
        this.residentBuildingSubscription.unsubscribe();
      }
      if (this.managerBuildingSubscription) {
        this.managerBuildingSubscription.unsubscribe();
      }

      // Fetch building alerts based on the filtered buildings
      this.buildingService
        .getAllBuildingAlertsByBuiildingIds(this.filteredBuildings, this.id)
        .subscribe((buildings) => {
          console.log("Filtered buildings : ", buildings);
          this.buildingAlerts = buildings.alerts;
          for (let alert of this.buildingAlerts) {
            if (alert.building.length > 0) {
              filteredAlerts.push(alert);
            }
          }
          this.buildingAlerts = filteredAlerts;
          this.buildingAlertsLength = filteredAlerts.length;
        });
    }
    console.log("this.buildingAlertsLength", this.buildingAlertsLength);
  }

  /**
   * Reset building alerts creating and edit form and related variables
   */
  resetAlertForm() {
    this.buildingAlertForm.reset();
    this.expiryDateInvalid = false;
    this.subjectInvalid = false;
    this.messageInvalid = false;
    this.editExpiryDateInvalid = false;
    this.editSubjectInvalid = false;
    this.editMessageInvalid = false;
    $("div.checkbox_inputs")
      .find('input[type="checkbox"]')
      .each(function (index, ele) {
        console.log($(this));
        $(this).prop("checked", false);
      });
    this.selectedBuildings = [];
    this.Names = [];
    this.filteredBuildings = [];
    this.buildingNames = [];
    this.createdName = "";
    this.selectedBuildingsName = [];
    this.editedName = "";
    this.editCheckedBuildingName = [];
  }
}
